import { variant } from 'styled-system';

const createSemanticType = (type) => {
  return {
    backgroundColor: `${type}.50`,
    color: 'neutral.0',
  };
};

const solidTypeVariant = () =>
  variant({
    prop: 'type',
    variants: {
      positive: createSemanticType('positive'),
      informative: createSemanticType('info'),
      warning: createSemanticType('warning'),
      critical: createSemanticType('critical'),
      neutral: {
        backgroundColor: 'neutral.80',
        color: 'neutral.0',
      },
    },
  });

export default solidTypeVariant;
